import { atom } from "recoil";

const AreaFilterAtom = atom({
    default: 'all',
    key: 'areaFilterAtom'
})

export default AreaFilterAtom;